export default "__VITE_ASSET__CAeqhMe8__"